import { mapActions, mapGetters } from 'vuex'
import DirectorBigQueryView from '@/views/Director/components/DirectorBigQueryView.vue'
import DirectorGoogleAnalyticsView from '@/views/Director/components/DirectorGoogleAnalyticsView.vue'
import { resolveDirectorView } from '@/views/Director/director.helpers'

export default {
  name: 'Director',
  data () {
    return {
      calendarOpen: false,
      datesFilter: [],
      isLoadingContext: false
    }
  },
  computed: {
    ...mapGetters([
      'activeContentplan',
      'integrations'
    ]),
    contentplanId () {
      return parseInt(this.$route.params.contentplanId, 10)
    },
    workspaceId () {
      return parseInt(this.$route.params.workspaceId, 10)
    },
    contentplanName () {
      return this.activeContentplan?.name ?? ''
    },
    contentplanType () {
      return this.activeContentplan?.type || 'managed'
    },
    sharingKey () {
      return this.$route.params.sharingKey || ''
    },
    isSharedView () {
      return Boolean(this.sharingKey)
    },
    analyticsIntegration () {
      return this.integrations?.find(item => item.type === 'ga-4') || {}
    },
    activeIntegrationView () {
      return resolveDirectorView(this.analyticsIntegration)
    }
  },
  methods: {
    ...mapActions([
      'contentplanGetOne',
      'getIntegrations'
    ]),
    formatDate (date) {
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    },
    setDates (days) {
      const endDate = new Date()
      const startDate = new Date()

      startDate.setDate(startDate.getDate() - days - 3)
      endDate.setDate(endDate.getDate() - 3)
      this.datesFilter = [this.formatDate(startDate), this.formatDate(endDate)]
    },
    getYearlyDateRange () {
      const today = new Date()
      const endDate = new Date(today.getFullYear(), today.getMonth(), 0)
      const startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 11, 1)

      return [
        this.formatDate(startDate),
        this.formatDate(endDate)
      ]
    },
    async loadDirectorContext () {
      this.isLoadingContext = true
      try {
        await Promise.all([
          this.contentplanGetOne({ contentplanId: this.contentplanId }),
          this.getIntegrations({ contentplanId: this.contentplanId })
        ])
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoadingContext = false
      }
    },
    handleSelectDate () {
      this.calendarOpen = false
    }
  },
  async mounted () {
    document.title = 'Director View | ContentGecko'
    this.datesFilter = this.getYearlyDateRange()
    await this.loadDirectorContext()
  },
  components: {
    DirectorBigQueryView,
    DirectorGoogleAnalyticsView
  }
}
